export default __webpack_public_path__ + "static/media/fw-harper-er-Yellow Gold.a89674f9.mp4";